import React, { useState } from "react"
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
  Spinner
} from "reactstrap"

import Images from "utils/Images"

import useForm from "utils/useForm"
import validator from "utils/validation"
import { forgotRequest } from "./redux/actions"
import { connect } from "react-redux"

import { Link } from "react-router-dom"

const ForgotPassword = props => {
  const stateSchema = {
    email: {
      value: "",
      error: ""
    }
  }

  const validationStateSchema = {
    email: {
      required: true,
      validator: validator.email
    }
  }

  const { state, handleOnChange, disable } = useForm(
    stateSchema,
    validationStateSchema
  )

  const onForgot = () => {
    const data = {
      email: state.email.value
    }
    props.forgotRequest(data)
  }

  const [emailVerification, setEmailVerification] = useState(false)

  return (
    <div>
      <div className="login-page">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" lg="6" md="8" sm="">
              <Form action="" className="form" method="">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 50
                  }}
                >
                  <img
                    alt=""
                    style={{
                      height: "64px",
                      width: "64px",
                      borderRadius: 0,
                      marginRight: "13px",
                      marginTop: -3
                    }}
                    src={Images.cardLogo}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center"
                  }}
                >
                  <Card className="card-login w-75 p-0" style={{}}>
                    <CardBody>
                      <br />
                      <FormGroup>
                        <p
                          style={{
                            color: "#000000",
                            fontWeight: "600",
                            fontSize: 20,
                            textAlign: "center"
                          }}
                        >
                          Forgot Password
                        </p>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#838181"
                          }}
                        >
                          To reset your password please provide
                        </p>
                        <p
                          style={{
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#838181",
                            marginTop: "-20px"
                          }}
                        >
                          your email
                        </p>
                      </FormGroup>
                      <Form action="" className="form" method="">
                        <InputGroup
                          className="no-border"
                          style={{
                            border: "1.5px solid #808080",
                            borderRadius: "6px"
                          }}
                        >
                          <InputGroupAddon addonType="append">
                            <InputGroupText
                              style={{ backgroundColor: "white" }}
                            >
                              <img
                                alt=""
                                style={{
                                  height: "15px",
                                  width: "19px"
                                }}
                                email_logo="true"
                                src={Images.emailLogo}
                              />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Type email"
                            type="email"
                            style={{
                              backgroundColor: "white",
                              height: "52px",
                              border: "3px solid white"
                            }}
                            onChange={e => {
                              handleOnChange("email", e.target.value)
                              if (validator.email.regEx.test(e.target.value)) {
                                setEmailVerification(true)
                              } else {
                                setEmailVerification(false)
                              }
                            }}
                          />
                          <InputGroupAddon addonType="append">
                            <InputGroupText
                              style={{ backgroundColor: "white" }}
                            >
                              {emailVerification && (
                                <img
                                  alt=""
                                  style={{
                                    height: "9px",
                                    width: "11px"
                                  }}
                                  email_logo="true"
                                  src={Images.tick}
                                />
                              )}
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                        {state.email.error && (
                          <label
                            style={{
                              color: "red",
                              display: "flex",
                              textAlign: "left",
                              marginTop: -6
                            }}
                          >
                            {state.email.error}
                          </label>
                        )}
                      </Form>
                    </CardBody>
                    <CardFooter>
                      <div
                        style={{
                          flexDirection: "row",
                          display: "flex",
                          justifyContent: "space-evenly",
                          paddingBottom: "30px",
                          marginLeft: 10,
                          marginRight: 10
                        }}
                      >
                        <Button
                          className="mr-md-n2 text-capitalize"
                          style={{
                            backgroundColor: "#F01716",
                            height: 46,
                            fontWeight: "700",
                            fontSize: "16px",
                            borderRadius: "6px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                            marginTop: -25,
                            width: 190
                          }}
                          onClick={() => onForgot()}
                          disabled={disable}
                        >
                          {props.requesting ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    </CardFooter>
                  </Card>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Link to="/auth/login" style={{ textDecoration: "none" }}>
                    <Button
                      className=" text-capitalize"
                      style={{
                        backgroundColor: "transparent",
                        height: "50px",
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "white",
                        border: "1px solid white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "8px",
                        marginRight: 20
                      }}
                    >
                      <img
                        alt=""
                        style={{
                          height: "16px",
                          width: "9px",
                          borderRadius: 0,
                          marginRight: "13px",
                          marginTop: -3
                        }}
                        src={Images.goBack}
                      />
                      Back to Sign In Page
                    </Button>
                  </Link>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("assets/img/forgotBg.png")})`
          }}
        ></div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  requesting: state.ForgotPassword.requesting
})

const mapDispatchToProps = dispatch => ({
  forgotRequest: data => dispatch(forgotRequest(data))
})
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
